"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LARGE_TEXT_STORAGE_KEY = exports.THEME_STORAGE_KEY = exports.MEDIA = exports.MEDIA_QUERY = void 0;
const lit_1 = require("lit");
const BREAKPOINT = {
    wide: '1560px',
    default: '1200px',
    narrow: '800px',
    compact: '480px',
};
exports.MEDIA_QUERY = {
    wide: `(max-width: ${BREAKPOINT.wide})`,
    default: `(max-width: ${BREAKPOINT.default})`,
    narrow: `(max-width: ${BREAKPOINT.narrow})`,
    compact: `(max-width: ${BREAKPOINT.compact})`,
};
exports.MEDIA = {
    wide: (0, lit_1.unsafeCSS)(exports.MEDIA_QUERY.wide),
    default: (0, lit_1.unsafeCSS)(exports.MEDIA_QUERY.default),
    narrow: (0, lit_1.unsafeCSS)(exports.MEDIA_QUERY.narrow),
    compact: (0, lit_1.unsafeCSS)(exports.MEDIA_QUERY.compact),
};
exports.THEME_STORAGE_KEY = 'theme';
exports.LARGE_TEXT_STORAGE_KEY = 'large-text';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw2QkFBK0I7QUFFL0IsTUFBTSxVQUFVLEdBQUc7SUFDakIsSUFBSSxFQUFFLFFBQVE7SUFDZCxPQUFPLEVBQUUsUUFBUTtJQUNqQixNQUFNLEVBQUUsT0FBTztJQUNmLE9BQU8sRUFBRSxPQUFPO0NBQ1IsQ0FBQTtBQUVHLFFBQUEsV0FBVyxHQUFHO0lBQ3pCLElBQUksRUFBRSxlQUFlLFVBQVUsQ0FBQyxJQUFJLEdBQUc7SUFDdkMsT0FBTyxFQUFFLGVBQWUsVUFBVSxDQUFDLE9BQU8sR0FBRztJQUM3QyxNQUFNLEVBQUUsZUFBZSxVQUFVLENBQUMsTUFBTSxHQUFHO0lBQzNDLE9BQU8sRUFBRSxlQUFlLFVBQVUsQ0FBQyxPQUFPLEdBQUc7Q0FDckMsQ0FBQTtBQUVHLFFBQUEsS0FBSyxHQUFHO0lBQ25CLElBQUksRUFBRSxJQUFBLGVBQVMsRUFBQyxtQkFBVyxDQUFDLElBQUksQ0FBQztJQUNqQyxPQUFPLEVBQUUsSUFBQSxlQUFTLEVBQUMsbUJBQVcsQ0FBQyxPQUFPLENBQUM7SUFDdkMsTUFBTSxFQUFFLElBQUEsZUFBUyxFQUFDLG1CQUFXLENBQUMsTUFBTSxDQUFDO0lBQ3JDLE9BQU8sRUFBRSxJQUFBLGVBQVMsRUFBQyxtQkFBVyxDQUFDLE9BQU8sQ0FBQztDQUMvQixDQUFBO0FBRUcsUUFBQSxpQkFBaUIsR0FBRyxPQUFPLENBQUE7QUFDM0IsUUFBQSxzQkFBc0IsR0FBRyxZQUFZLENBQUEifQ==